<template>
  <div
    v-if="showLoading"
    class="m-forget-password"
  >
    <AtomLoadingPrimary :loading-text="$t('mForgetPassword.message')"/>
  </div>
  <div
    v-else
    class="a-transition-fade m-card-primary m-forget-password"
  >
    <AtomLogoPrimary class="m-login-academy-name text-align-center font-size-xxlarge"/>
    <form
      autocomplete="off"
      class="a-form-column"
      name="forget-password-form"
      @submit.prevent="createUsuarioForgotPassword"
    >
      <p class="font-weight-bold text-color-academy-primary text-align-center">
        {{ $t('mForgetPassword.formInfo') }}
      </p>
      <p
        v-if="forgetPasswordSuccess"
        class="font-weight-bold text-color-success text-align-center"
      >
        {{ $t('mForgetPassword.alerts.success') }}
      </p>
      <p
        v-else
        class="font-weight-bold text-align-center"
      >
        {{ $t('mForgetPassword.descripcion') }}
      </p>
      <p
        v-if="forgetPasswordError"
        class="font-weight-bold text-color-danger text-align-center"
      >
        {{ $t('mForgetPassword.alerts.error') }}
      </p>
      <p
        v-if="forgetPasswordUser"
        class="font-weight-bold text-color-danger text-align-center"
      >
        {{ $t('mForgetPassword.alerts.user') }}
      </p>
      <AtomInputPrimary
        v-model="email"
        :inputError="$v.email.$error"
        :messageError="messageErrorEmail"
        name="email"
        :placeholder="$t('mForgetPassword.inputs.email.placeholder')"
        reference="email"
        type="email"
        @blur="$v.email.$touch()"
      />
      <AtomButtonPrimary :button-primary="buttonPrimary"/>
      <a
        class="text-color-academy-primary"
        href="#"
        @click.prevent="$router.go(-1)"
      >
        {{ $t('mForgetPassword.goBack') }}
      </a>
    </form>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'
import configApp from '@/config'

export default {
  name: 'MoleculeForgetPassword',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mForgetPassword.buttonPrimary'),
        behavior: 'login',
        class: 'a-button-academy-primary a-button-login',
        sending: false,
        type: 'submit'
      },

      email: '',

      forgetPasswordSuccess: false,

      forgetPasswordError: false,

      forgetPasswordUser: false,

      showLoading: true
    }
  },

  validations: {
    email: {
      email,
      required
    }
  },

  computed: {
    messageErrorEmail () {
      return this.$validation.getValidationMessage('mForgetPassword', this.$v.email, 'email')
    }
  },

  created () {
    this.email = this.$route.query.email
    this.academiaId = this.$route.query.academia_id ? this.$route.query.academia_id : ''
    if (this.academiaId !== '') {
      this.readAcademia()
    } else {
      this.showLoading = false
    }
  },

  methods: {
    createUsuarioForgotPassword () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.forgetPasswordSuccess = false
        this.forgetPasswordError = false
        this.forgetPasswordUser = false
        this.$services.create('usuario', 'createUsuarioForgotPassword', { email: this.email, academia_id: this.academiaId, url: configApp.appDomain })
          .then(response => {
            if (!response.data.error && response.data.type === 'cognito') {
              this.forgetPasswordSuccess = true
            } else if (!response.data.error && response.data.type === 'auth0') {
              this.forgetPasswordSuccess = true
            } else {
              this.forgetPasswordUser = true
            }
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.forgetPasswordError = true
          })
      }
    },

    readAcademia () {
      this.$services.read('academia', 'readAcademia', {}, [this.academiaId])
        .then(response => {
          console.log(response.data)
          localStorage.setItem('current_academy', JSON.stringify(response.data))
          this.$store.commit('setAcademyData', response.data)
          this.showLoading = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
